module.exports = __webpack_public_path__ + "static/media/urbangoo21.c79f792b.webp";